export const emsDoctorInquiry = '/ems-inquiry/doctor';
